import React, { useState, useEffect, useCallback } from 'react';
import { Tabs, theme } from 'antd';
import { ShopOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';

import SellerAccountSettings from './components/SellerAccountSettings';
import { fetchSellerAccounts } from './actions';
import './AdminSettings.css';

const { TabPane } = Tabs;

const AdminSettings = () => {
    const dispatch = useDispatch();
    const { sellerAccounts, loading } = useSelector(state => state.adminSettings);
    const [activeKey, setActiveKey] = useState('seller');
    const [loadedTabs, setLoadedTabs] = useState(new Set(['seller'])); // Track which tabs have been loaded
    const {
        token: { colorBgContainer, borderRadiusLG },
    } = theme.useToken();

    // Load initial tab data on mount
    useEffect(() => {
        // Load seller accounts initially
        dispatch(fetchSellerAccounts());
    }, [dispatch]);

    // Memoize the data fetching functions
    const fetchTabData = useCallback(async (tabKey) => {
        if (loadedTabs.has(tabKey)) {
            return; // Tab already loaded, no need to fetch again
        }

        try {
            switch (tabKey) {
                case 'seller':
                    await dispatch(fetchSellerAccounts());
                    break;
                default:
                    break;
            }
            
            // Mark tab as loaded
            setLoadedTabs(prev => new Set([...prev, tabKey]));
        } catch (error) {
            console.error(`Error loading data for tab ${tabKey}:`, error);
        }
    }, [dispatch, loadedTabs]);

    const handleTabChange = useCallback((key) => {
        setActiveKey(key);
        // Fetch data for the new tab if not already loaded
        fetchTabData(key);
    }, [fetchTabData]);

    return (
        <div
            style={{
                margin: '24px 16px',
                borderRadius: borderRadiusLG,
                minHeight: 280,
            }}
        >
            <Tabs
                activeKey={activeKey}
                onChange={handleTabChange}
                type="card"
                tabBarGutter={5}
                className="admin-settings-tabs"
            >
                <TabPane
                    tab={<span><ShopOutlined /> Seller Account</span>}
                    key="seller"
                >
                    <SellerAccountSettings
                        sellerAccounts={sellerAccounts}
                        loading={loading}
                    />
                </TabPane>
            </Tabs>
        </div>
    );
};

export default AdminSettings;